import React from 'react';
import styled from "styled-components";


export const FooterWrapper = styled.footer`
	position: relative;
	background-color: var(--text);
		  
	.footer-logo {
		width: 80px;
	}
	.f-logo-wrap {
		display: flex;
		align-items: start;
		justify-content: start;
	}
  
	.footerContain{
		padding-bottom: 40px;
	}
	.footerContain2{
		padding-top: 23px;
  		padding-bottom: 23px;
	}
	.exFoot{
		width: 160px !important;
	}
    .footer-row{
        display: flex;
        justify-content: center;
        & > div{
          width: fit-content;
        }
    }
	.ministryLogosWrapper{
		display: flex;
		align-items: center;
		
	}
	.footer-list{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 25px;
    & a{
        color: var(--themeColor);
        font-family: var(--familyRbt);
    font-weight: var(--regular);
	white-space: nowrap;
        &:hover{
            // color: var(--text);
        }
    }
} 

	.footer-list a{
		color:var(--themeColor);
		padding-bottom: 8px;
		position: relative;
		font-size:16px;
		font-family: var(--familyRbt);
		font-weight: var(--regular);
		&:hover, &.active, &:focus{
			color:var(--themeColor);
			font-family: var(--semibold);
			font-weight: 400;
			text-decoration: underline;
			&::before, &.active::before{
				content: '';
				position: absolute;
				bottom: 0;
				right: 0;
				left: 0;
				margin: auto;
				width: 15px;
				height: 3px;
				background: var(--lightgreen);
			}
		}
	}
	.minLogo{
		border-right: 2px solid var(--bg2);
		padding-left: 16px;
		padding-right: 16px;
		&:last-child{
			padding-right: 0;
			border-right: 0;
		}
	}
	.copyright{
		
	}
	.cWhite{
		color: var(--white);
	}
	body.rtl &{
		.minLogo{
			border-right: none;
			border-left: 2px solid var(--bg2);
			&:last-child{
				padding-right: 16px;
				border-left: 0;
			}
		}
		.footer-list a{
			font-family: var(--arRegular);
			font-weight: var(--regular);
		}
		
	}
	
	@media (max-width: 991px) {
		.footer-row{
			flex-wrap: wrap;
		}
		.ministryLogosWrapper{
			width: 100% !important;
			margin-top: 20px;
			justify-content: center;
	}
	}
	@media (max-width: 575px) {
		.footer-row{
			.copyright {
				width: 100%;
				margin-top: 20px !important;
			}
		}
		.footer-list {
			flex-wrap: wrap;
			gap: 10px;
			a{
				padding-bottom: 0px;
			}
		}

  
	}
		
		
		 
		
`;
